import { isly } from "isly";
import { Iso88591 } from "./Iso88591";
import { Utf8 } from "./Utf8";
export var Encoding;
(function (Encoding) {
    var _a;
    Encoding.values = [
        "UTF-8",
        "UTF-16",
        "UTF-32",
        "ASCII",
        "CP037",
        "CP930",
        "CP1047",
        "ISO-8859-1",
        "ISO-8859-2",
        "ISO-8859-3",
        "ISO-8859-4",
        "ISO-8859-5",
        "ISO-8859-6",
        "ISO-8859-7",
        "ISO-8859-8",
        "ISO-8859-9",
        "ISO-8859-10",
        "ISO-8859-11",
        "ISO-8859-13",
        "ISO-8859-14",
        "ISO-8859-15",
        "ISO-8859-16",
        "CP437",
        "CP720",
        "CP737",
        "CP850",
        "CP852",
        "CP855",
        "CP857",
        "CP858",
        "CP860",
        "CP861",
        "CP862",
        "CP863",
        "CP865",
        "CP866",
        "CP869",
        "CP872",
        "Windows-1250",
        "Windows-1251",
        "Windows-1252",
        "Windows-1253",
        "Windows-1254",
        "Windows-1255",
        "Windows-1256",
        "Windows-1257",
        "Windows-1258",
        "Mac OS Roman",
        "KOI8-R",
        "KOI8-U",
        "KOI7",
        "MIK",
        "ISCII",
        "TSCII",
        "VISCII",
        "Shift_JIS",
        "EUC-JP",
        "ISO-2022-JP",
        "Shift_JIS-2004",
        "EUC-JIS-2004",
        "ISO-2022-2004",
        "GB 2312",
        "GBK",
        "GB 18030",
        "Big5",
        "HKSCS",
        "KS X 1001",
        "EUC-KR",
        "ISO-2022-KR",
        "T.51",
    ];
    _a = isly
        .string("value", ...Encoding.values)
        .rename("isoly.Encoding")
        .bind(), Encoding.type = _a.type, Encoding.is = _a.is, Encoding.flawed = _a.flawed;
    function parse(value) {
        let result;
        switch (value.toUpperCase()) {
            case "UTF-8":
            case "UTF8":
            case "UTF 8":
                result = "UTF-8";
                break;
            case "UTF-16":
                result = "UTF-16";
                break;
            case "UTF-32":
                result = "UTF-32";
                break;
            case "US-ASCII":
            case "ASCII":
                result = "ASCII";
                break;
            case "CP037":
                result = "CP037";
                break;
            case "CP930":
                result = "CP930";
                break;
            case "CP1047":
                result = "CP1047";
                break;
            case "ISO-IR-100":
            case "CSISOLATIN1":
            case "LATIN1":
            case "LATIN-1":
            case "L1":
            case "IBM819":
            case "CODE PAGE 28591":
            case "WINDOWS-28591":
            case "CODE PAGE 819":
            case "CP819":
            case "CCSID 819":
            case "WE8ISO8859P1":
            case "ISO 8859-1":
            case "ISO-8859-1":
                result = "ISO-8859-1";
                break;
            case "ISO-8859-2":
                result = "ISO-8859-2";
                break;
            case "ISO-8859-3":
                result = "ISO-8859-3";
                break;
            case "ISO-8859-4":
                result = "ISO-8859-4";
                break;
            case "ISO-8859-5":
                result = "ISO-8859-5";
                break;
            case "ISO-8859-6":
                result = "ISO-8859-6";
                break;
            case "ISO-8859-7":
                result = "ISO-8859-7";
                break;
            case "ISO-8859-8":
                result = "ISO-8859-8";
                break;
            case "ISO-8859-9":
                result = "ISO-8859-9";
                break;
            case "ISO-8859-10":
                result = "ISO-8859-10";
                break;
            case "ISO-8859-11":
                result = "ISO-8859-11";
                break;
            case "ISO-8859-13":
                result = "ISO-8859-13";
                break;
            case "ISO-8859-14":
                result = "ISO-8859-14";
                break;
            case "ISO-8859-15":
                result = "ISO-8859-15";
                break;
            case "ISO-8859-16":
                result = "ISO-8859-16";
                break;
            case "CP437":
                result = "CP437";
                break;
            case "CP720":
                result = "CP720";
                break;
            case "CP737":
                result = "CP737";
                break;
            case "CP850":
                result = "CP850";
                break;
            case "CP852":
                result = "CP852";
                break;
            case "CP855":
                result = "CP855";
                break;
            case "CP857":
                result = "CP857";
                break;
            case "CP858":
                result = "CP858";
                break;
            case "CP860":
                result = "CP860";
                break;
            case "CP861":
                result = "CP861";
                break;
            case "CP862":
                result = "CP862";
                break;
            case "CP863":
                result = "CP863";
                break;
            case "CP865":
                result = "CP865";
                break;
            case "CP866":
                result = "CP866";
                break;
            case "CP869":
                result = "CP869";
                break;
            case "CP872":
                result = "CP872";
                break;
            case "WINDOWS-1250":
                result = "Windows-1250";
                break;
            case "WINDOWS-1251":
                result = "Windows-1251";
                break;
            case "WINDOWS-1252":
                result = "Windows-1252";
                break;
            case "WINDOWS-1253":
                result = "Windows-1253";
                break;
            case "WINDOWS-1254":
                result = "Windows-1254";
                break;
            case "WINDOWS-1255":
                result = "Windows-1255";
                break;
            case "WINDOWS-1256":
                result = "Windows-1256";
                break;
            case "WINDOWS-1257":
                result = "Windows-1257";
                break;
            case "WINDOWS-1258":
                result = "Windows-1258";
                break;
            case "MAC OS ROMAN":
                result = "Mac OS Roman";
                break;
            case "KOI8-R":
                result = "KOI8-R";
                break;
            case "KOI8-U":
                result = "KOI8-U";
                break;
            case "KOI7":
                result = "KOI7";
                break;
            case "MIK":
                result = "MIK";
                break;
            case "ISCII":
                result = "ISCII";
                break;
            case "TSCII":
                result = "TSCII";
                break;
            case "VISCII":
                result = "VISCII";
                break;
            case "SHIFT_JIS":
                result = "Shift_JIS";
                break;
            case "EUC-JP":
                result = "EUC-JP";
                break;
            case "ISO-2022-JP":
                result = "ISO-2022-JP";
                break;
            case "SHIFT_JIS-2004":
                result = "Shift_JIS-2004";
                break;
            case "EUC-JIS-2004":
                result = "EUC-JIS-2004";
                break;
            case "ISO-2022-2004":
                result = "ISO-2022-2004";
                break;
            case "GB 2312":
                result = "GB 2312";
                break;
            case "GBK":
                result = "GBK";
                break;
            case "GB 18030":
                result = "GB 18030";
                break;
            case "BIG5":
                result = "Big5";
                break;
            case "HKSCS":
                result = "HKSCS";
                break;
            case "KS X 1001":
                result = "KS X 1001";
                break;
            case "EUC-KR":
                result = "EUC-KR";
                break;
            case "ISO-2022-KR":
                result = "ISO-2022-KR";
                break;
            case "T.51":
                result = "T.51";
                break;
        }
        return result;
    }
    Encoding.parse = parse;
    function encode(encoding, data) {
        return transcoders[encoding].encode(data);
    }
    Encoding.encode = encode;
    function decode(encoding, data) {
        return transcoders[encoding].decode(data);
    }
    Encoding.decode = decode;
    const transcoders = {
        "ISO-8859-1": new Iso88591(),
        "UTF-8": new Utf8(),
    };
})(Encoding || (Encoding = {}));
//# sourceMappingURL=index.js.map